<template>
  <li>
    <slot :expand="sectionExpand" />
  </li>
</template>

<script>
import eventBus from '@/js/util/eventBus'

export default {
  data() {
    return {
      expanded: false,
      mouseIsOver: false,
    }
  },
  props: {
    section: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  methods: {
    sectionExpand(expand) {
      setTimeout(() => {
        if (this.type == 'toggle' && this.mouseIsOver) {
          // close other expanded links
          eventBus.$emit('nav:desktop:collapse')
          this.expanded = expand
          eventBus.$emit('nav:desktop:opened', this.expanded)
          eventBus.$emit('nav:desktop:' + this.section, this.expanded)
          eventBus.$emit(
            'nav:desktop:' + this.section + ':update',
            this.expanded
          )
        }
      }, 500)
    },
  },
  /* mounted() {
    eventBus.$on('nav:desktop:' + this.section + ':focus', this.sectionExpand(true))
  } */
}
</script>
